import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserErrorComponent } from './user-error/user-error.component';
import { GeneralErrorComponent } from './general-error/general-error.component';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { PseErrorComponent } from './pse-error/pse-error.component';
import { OtpErrorComponent } from './otp-error/otp-error.component';
import { PsePendingErrorComponent } from './pse-pending-error/pse-pending-error.component';
import { ReadSummaryErrorComponent } from './read-summary-error/read-summary-error.component';
import { ReadSummaryPseErrorComponent } from './read-summary-pse-error/read-summary-pse-error.component';
import { TimeErrorComponent } from './time-error/time-error.component';
import { NoIdentityErrorComponent } from './biometrics/no-identity-error/no-identity.component';
import { TechFailedComponent } from './biometrics/tech-failed/tech-failed.component';
import { CameraErrorComponent } from './biometrics/camera-error/camera-error.component';
import { NoAccountsErrorComponent } from './no-accounts-error/no-accounts-error.component';

const routes: Routes = [
  {
    path: routesData.ERRORS.USER_ERROR.path,
    component: UserErrorComponent
  },
  {
    path: routesData.ERRORS.GENERAL_ERROR.path,
    component: GeneralErrorComponent
  },
  {
    path: routesData.ERRORS.SUMMARY_ERROR.path,
    component: ReadSummaryErrorComponent
  },
  {
    path: routesData.ERRORS.SUMMARY_PSE_ERROR.path,
    component: ReadSummaryPseErrorComponent
  },
  {
    path: routesData.ERRORS.PSE_ERROR.path,
    component: PseErrorComponent
  },
  {
    path: routesData.ERRORS.PSE_PENDING_ERROR.path,
    component: PsePendingErrorComponent
  },
  {
    path: routesData.ERRORS.OTP_ERROR.path,
    component: OtpErrorComponent
  },
  {
    path: routesData.ERRORS.TIME_ERROR.path,
    component: TimeErrorComponent
  },
  {
    path: routesData.ERRORS.NO_IDENTITY.path,
    component: NoIdentityErrorComponent
  },
  {
    path: routesData.ERRORS.TECH_FAILED.path,
    component: TechFailedComponent
  },
  {
    path: routesData.ERRORS.CAMERA.path,
    component: CameraErrorComponent
  },
  {
    path: routesData.ERRORS.NO_ACCOUNTS_ERROR.path,
    component: NoAccountsErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorsRoutingModule {}
